import * as React from 'react';
import Button from 'antd/lib/button';
import Collapse from 'antd/lib/collapse';
import Icon from 'antd/lib/icon';
import message from 'antd/lib/message';
import Modal from 'antd/lib/modal';
import Progress from 'antd/lib/progress';
import Table from 'antd/lib/table';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { editShipmentTask, form13RequestOdexRefNumber } from 'src/api/shipmentExecution';
import ApiDto from 'src/dto/ApiDto';
import { FetchShipmentTasksData, SETask } from 'src/dto/response/fetchShipmentTasks';
import useVisibility from 'src/hooks/useVisibility';
import { OrgTypes, InquiryModes } from 'src/Library/Constants';
import masterDataProto from 'src/Library/MasterDataType';
import { StylesProps } from 'src/Library/Types';
import { useGenericState } from 'src/Library/UseGenericState';
import { SHIPMENT_TYPE } from '../../../../Container/ContainerUtils';
import SEAddTaskDetailModal from '../addEdit/SEAddTaskDetailModal.view';
import SEAddTaskModal from '../addEdit/SEAddTaskModal';
import SEAddTaskProtip from '../addEdit/SEAddTaskProtip';
import SEEditTaskProtip from '../addEdit/SEEditTaskProtip';
import SETaskBlockerModal from '../SETaskBlockerModal';
import SETaskRejectionModal from '../SETaskRejectionModal';
import styles from './SETasksList.styles';
import { MilestoneCodes } from '../../../SE.constants';
import { fetchDropdownMasterdata, updateCardDataAtIndex , fetchPendingContainerCount } from 'src/actions/shipmentExecutionActions';
import SEModalWrapper from '../SEModalWrapper';
import SETasksListRow from './SETasksListRow';
import { stops , isValidString } from 'src/Library/Helper';
import Loader from 'src/components/common/Loader';
import { useEffect } from 'react';
import { ApprovalTaskStatusOptions } from '../SETasksUtils';
import { bindActionCreators } from 'redux';
import GetExecutionData from 'src/dto/response/getExecution';
import GenericHoc from 'src/components/hoc/GenericHoc';
import { SEOrgType } from '../../../SE.interfaces';
import UploadSIModal from './UploadSIModal';
import UploadSISuccessModal from './UploadSISuccessModal';
import FileVGMModal from './FileVGMModal';
import FileOdexSuccessModal from './FileOdexSuccessModal';
import isEmpty from 'lodash/isEmpty';
import { getOrgPrettyName } from 'src/api/utils';
import Form13RequestDetailsForm from './Form13RequestDetailsForm';
import Form13UploadModal from './Form13UploadModal';
import { Spin } from 'src/Library/AntdLibComponents';
import { ExecutionDetails } from '../../SEDetails/shipment-details.types';
import { documentRequestTabs } from '../../document-request/document-request.constants';

interface SETasksListProps extends StylesProps<ReturnType<typeof styles>> {
  sourceObjectId: string;
  selectedShipment: GetExecutionData & { index: number };
  fetchTasks: (sourceObjectId: string, showLoader?: boolean) => Promise<void>;
  handleSort: (col: string, order: 'asc' | 'desc') => void;
  taskDocuments: string[];
  tasks: FetchShipmentTasksData;
  isLoading: boolean;
  isTask: boolean;
  permissions: typeof masterDataProto.permissions;
  type: SEOrgType;
  currentUserEmail: string;
  currentShipmentMilestone: keyof FetchShipmentTasksData;
  isAddTaskDetailModalWrapperVisible: boolean;
  isAddTaskDetailModalVisible: boolean;
  setIsTaskDetailsVisible: (flag: boolean) => void;
  gotoContainerTrackingTab: () => void;
  showInttraShippingInstructions: boolean;
  inttraCode: string;
  siPendingCount;
  fetchPendingContainerCount: (shipmentId) => Promise<void>;
  odexVgmReferenceNumber: string;
  odexForm13ReferenceNumber: string;
  setTasksTab: () => void;
  shippingLines: { dbId, scacCode }[];
  shipmentDetails: ExecutionDetails | undefined;
  gotoDocumentRequest: (activeSubTab: keyof typeof documentRequestTabs) => void;
  updateCardData: () => void;
}

const SETasksList: React.FC<SETasksListProps> = ({
  classes,
  sourceObjectId,
  selectedShipment,
  fetchTasks,
  handleSort,
  tasks,
  isLoading,
  isTask,
  permissions,
  type,
  currentUserEmail,
  currentShipmentMilestone,
  setIsTaskDetailsVisible,
  gotoContainerTrackingTab,
  showInttraShippingInstructions,
  inttraCode,
  siPendingCount,
  fetchPendingContainerCount,
  odexVgmReferenceNumber,
  odexForm13ReferenceNumber,
  setTasksTab,
  shippingLines,
  shipmentDetails,
  gotoDocumentRequest,
  updateCardData,
}) => {
  const dispatch = useDispatch();

  const isInttraSIAllowed = Boolean(shippingLines?.some(item =>
    item.dbId === shipmentDetails?.carrierId && isValidString(item.scacCode)));

  const initialState = {
    sortSelected: {} as {
      col: string;
      dir: 'asc' | 'desc';
    },
    editTaskData: {} as SETask, // | Pick<SETask, 'milestone'>,
    editTaskSessionData: undefined,
    detailId: undefined,
    isDetailModalEditable: false,
    isDocUploading: false,
    documentTaskId: undefined,
    documentViewData: '',
    viewDocTaskId: '',
    taskStatusLoading: {},
    record: {},
    blockingTasks: [],
    detailRemark: '',
    isAddTaskDetailModalWrapperVisible: false, 
    isAddTaskDetailModalVisible: false,
    isUploadSIModalVisible: false,
    isSISuccessModalVisible: false,
    isFileVgmModalVisible: false,
    isOdexRequestSuccessModalVisible: false,
    isRetryError: false,
    retryRequestData: {},
    odexSuccessResponse: {},
    odexRequestBody: {},
    isRequestingOdexNumber: false,
    isForm13RequestDetailsModalVisible: false,
    isForm13UploadModalVisible: false,
    siTaskid: '',
    odexFormType: '',
    docEditTaskSessionData: undefined,
  };

  const [state, setState] = useGenericState<typeof initialState>(initialState);
  const modals = useVisibility([
    'edit',
    'addTask',
    'detail',
    'uploadDocument',
    'taskBlocker',
    'fieldMissing',
    'taskCreatedProtip',
    'taskEditedProtip',
    'taskHistory',
    'taskRejection',
    'sailingSchedule',
    'selectFFBid',
  ]);

  const {
    sortSelected,
    editTaskData,
    editTaskSessionData,
    taskStatusLoading,
    blockingTasks,
    isDetailModalEditable,
    isAddTaskDetailModalWrapperVisible, 
    isAddTaskDetailModalVisible,
    isSISuccessModalVisible,
    isUploadSIModalVisible,
    siTaskid,
    isFileVgmModalVisible,
    isOdexRequestSuccessModalVisible,
    isRetryError,
    retryRequestData,
    odexSuccessResponse,
    odexRequestBody,
    isRequestingOdexNumber,
    isForm13RequestDetailsModalVisible,
    odexFormType,
    isForm13UploadModalVisible,
    docEditTaskSessionData
  } = state;

  const currentTaskId = editTaskData?.approvalStatus ? editTaskData?.mainTaskId || editTaskData?.id : editTaskData?.id;
  const onHold = currentShipmentMilestone === 'ON_HOLD' || currentShipmentMilestone === 'DELETED';

  const carrierAndPortOdexCodeCheck =
    isValidString(shipmentDetails?.carrierOdexLinerId) &&
    (
      (
        isValidString(shipmentDetails?.originPolCode) &&
        isValidString(shipmentDetails?.originPolOdexCode)
      ) ||
      (
        isValidString(shipmentDetails?.originPortCode) &&
        isValidString(shipmentDetails?.originPortOdexCode)
      )
    );

  useEffect(() => {
    setIsTaskDetailsVisible(isAddTaskDetailModalVisible);
  }, [isAddTaskDetailModalVisible]);

  useEffect(() => {
    componentDidMount();
  }, [sourceObjectId]);

  useEffect(() => {
    if (sortSelected?.col) {
      handleSort(sortSelected.col, sortSelected.dir);
    }
  }, [sortSelected]);

  useEffect(() => {
    setState({
      isAddTaskDetailModalWrapperVisible: false,
      isAddTaskDetailModalVisible: false,
    });
  }, [sourceObjectId]);

  const componentDidMount = async () => {
    await fetchTasks(sourceObjectId);
    await fetchPendingContainerCount({ shipmentId: sourceObjectId });
    dispatch(fetchDropdownMasterdata(sourceObjectId));
  };

  const refreshAddDetailTaskModal = async (taskId: string) => {
    let modalToToggle = 'isAddTaskDetailModalWrapperVisible';
    if (taskId === currentTaskId) {
      modalToToggle = 'isAddTaskDetailModalVisible'; 
    }

    setState({
      [modalToToggle]: false,
      editTaskData: undefined,
      isDetailModalEditable: false,
    }, async (_) => {
      const gotoTask = findTask(taskId);
      const isEditable = gotoTask && gotoTask.isEditable && gotoTask.status !== 'Done';
      setState({
        editTaskData: gotoTask,
        isDetailModalEditable: isEditable,
        [modalToToggle]: true,
      });
    });
  };

  const handleToggleWatch = async (record) => {
    const { isWatching, watcherList } = record;
    let newWatcherList;
    if (isWatching) newWatcherList = watcherList.filter((watcher) => watcher !== currentUserEmail);
    else {
      newWatcherList = watcherList?.length
        ? watcherList.concat(currentUserEmail)
        : [currentUserEmail];
    }

    const body = {
      ...record,
    };
    body.taskId = record.id;
    body.sourceObjectType = SHIPMENT_TYPE.SHIPMENT;
    body.sourceObjectId = sourceObjectId;
    body.watcherList = newWatcherList;

    const response = await editShipmentTask(
      {
        shipmentId: sourceObjectId,
        taskId: record.id,
      },
      body
    );

    if (response?.isSuccess) await fetchTasks(sourceObjectId, false);
    else message.error(response.errorMessage);
  };

  const handleUpdateStatus = async (status, record) => {
    modals.taskBlocker.hide();
    record.status = status;
    const body: typeof ApiDto.CreateShipmentTaskDto = {
      sourceObjectId,
      responsibleOrganisationId: record.responsibleOrganisationId,
      responsibleTeamId: record.responsibleTeamId,
      responsibleUserId: record.responsibleUserId,
      name: record.name,
      deadline: record.deadline,
      taskId: record?.id,
      sourceObjectType: 'SHIPMENT',
      status,
      deadlineDelta: record.deadlineDelta,
    } as any;
    setState({
      taskStatusLoading: {
        ...taskStatusLoading,
        [`${record?.id}`]: true,
      },
    });

    const editShipmentTaskParams = {
      shipmentId: sourceObjectId,
      taskId: record?.id,
    };

    const response = await editShipmentTask(editShipmentTaskParams, body);
    if (!response.isSuccess) {
      if (
        status === 'Done' &&
        response.errorMessage.includes('All mandatory fields must be present before')
      ) {
        modals.fieldMissing.show();
      } else {
        message.error(response.errorMessage);
      }
    } else {
      // TODO: commenting it because status Dropdown stays changed even if API fails, hence always fetching tasks
      // await fetchTasks(sourceObjectId);
    }
    setState({
      taskStatusLoading: {
        ...taskStatusLoading,
        [`${record?.id}`]: false,
      },
    });
    await fetchTasks(sourceObjectId, false);
    updateCardData();
  };

  const renderStatusDependencyTasks = (dependentTasksInDoneState) => {
    return (
      <div>
        <p>
          Changing the status of this task will change the status of the following tasks to 'In
          Progress'.
        </p>
        {dependentTasksInDoneState.map((task, idx) => (
          <p>
            Task {idx + 1} : <b>{task.name}</b>
          </p>
        ))}
      </div>
    );
  };

  const addTaskPermissionAccess = () => {
    return (
      (type === OrgTypes.SHIPPER && permissions?.SHIPMENT_TASK_ADD_EDIT_SHIPPER) ||
      (type === OrgTypes.FF && permissions?.SHIPMENT_TASK_ADD_EDIT_VENDOR)
    );
  };

  const handleCancel = () => {
    modals.fieldMissing.hide();
  };

  const renderAddTaskForNoTasks = () => {
    return (
      addTaskPermissionAccess() && (
        <div>
          <span style={{ width: '200px', fontSize: '18px', fontWeight: 600 }}>
            To get started,{' '}
            <a
              onClick={() => {
                modals.addTask.show();
              }}
            >
              Add a task
            </a>
          </span>
        </div>
      )
    );
  };

  const renderNoTasks = () => {
    return (
      <div className={classes.noTaskDiv}>
        <div>
          <span style={{ width: '200px', fontSize: '18px', fontWeight: 600 }}>
            You have not added any tasks.
          </span>
        </div>
        {renderAddTaskForNoTasks()}
      </div>
    );
  };

  const renderAddTask = ({ milestone }: { milestone: string }) => {
    return (
      <div onClick={(e) => {
        stops(e);
        modals.addTask.show();
        setState({
          editTaskData: { milestone } as any,
        });
      }} className={classes.addTaskDiv}
      style={{ color: onHold ? 'lightgrey' : '#1890FF',
        pointerEvents: onHold ? 'none' : 'auto',
        cursor: onHold ? 'not-allowed' : 'pointer'
      }}
      >
        + Add Task
      </div>
    );
  };

  const renderTableTitle = (columnLabels, col) => {
    return (
      <div
        style={{
          color: '#666666',
          fontFamily: "Open Sans",
          fontSize: 10,
          position: col === 'sequenceNumber' ? 'absolute' : 'relative',
          left: col === 'sequenceNumber' ? 16 : undefined,
        }}
      >
        {columnLabels[col]}
      </div>
    );
  };

  const renderColDeadline = (record: SETask) => {
    if (!record?.deadline) return <></>;
    const deadline = moment(record?.deadline);
    
    const crossedDeadline = isDeadlinePast(record);
    const nearDeadline = isDeadlineNear(record);
    const date: any = crossedDeadline
      ? `${deadline.format('DD MMM YYYY')}`
      : `${deadline.fromNow(true)} left`;
    
    return (
        <span
          style={{
            color: crossedDeadline || nearDeadline ? 'red' : '',
            fontStyle: crossedDeadline || nearDeadline ? 'italic' : undefined,
            fontSize: 10,
          }}
        >
          {date}
        </span>
    );
  };

  const isDeadlinePast = (record: SETask) =>
    record?.deadline && moment().valueOf() > record?.deadline;

  const isDeadlineNear = (record: SETask, hours: number = 35) => {
    const deadline = record?.deadline;
    return deadline && moment().add(hours, 'hours').valueOf() > deadline;
  }

  const handleShowTaskDetails = (record: SETask, isEditable: boolean) => {
    modals.detail.show();
    return setState({
      isAddTaskDetailModalWrapperVisible: true,
      isAddTaskDetailModalVisible: true,
      editTaskData: record,
      isDetailModalEditable: isEditable,
    });
  }

  const getColumns = () => {
    const columns = Object.keys(taskTableColumnLabels).map((col: any) => ({
      key: col,
      align: 'left',
      fixed: col === 'action' ? 'right' : false,
      width: getTaskTableWidths(col),
      title: () => renderTableTitle(taskTableColumnLabels, col),
      render: (text, record, index) => {
        return (
          <SETasksListRow
            record={record}
            col={col}
            index={index}
            taskStatusLoading={taskStatusLoading}
            handleUpdateStatus={handleUpdateStatus}
            handleShowTaskDetails={handleShowTaskDetails}
            handleToggleWatch={handleToggleWatch}
            currentShipmentMilestone={currentShipmentMilestone}
            renderThirdPartyActions={renderThirdPartyActions}
            messageForSI={messageForSI}
            isSubmitOnInttraButtonVisible={isSubmitOnInttraButtonVisible}
            messageForVGM={messageForVGM}
            isVGMButtonVisible={isVGMButtonVisible}
            messageForForm13={messageForForm13}
            isForm13ButtonVisible={isForm13ButtonVisible}
          />
        );
      },
    }));
    return columns;
  };

  const renderCollapseHeader = ({
    title,
    done,
    overdue,
    total,
    milestone,
  }: {
    title: string;
    done: number;
    overdue: number;
    total: number;
    milestone: {
      key: keyof FetchShipmentTasksData,
      label: string,
      data,
    },
  }) => {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex' }}>
          <div className={classes.milestoneName}>
            {title}
          </div>
          <div style={{ marginLeft: 24, whiteSpace: 'nowrap' }}>
            <span className={classes.taskDoneLabel}>Tasks Done:</span>
            <span style={{ width: 10, marginRight: 8, fontWeight: 600 }}>
              <span style={{ fontSize: 12, marginRight: 2 }}>{done}</span>
              <span style={{ fontSize: 10 }}>/{total}</span>
            </span>
            <span style={{ width: 50 }}>
              <Progress
                percent={((done + overdue) * 100) / total}
                successPercent={(done * 100) / total}
                showInfo={false}
                // strokeColor="#0FB356"
                strokeColor='#F75555'
                trailColor="#FAF9F6"
                strokeLinecap='square'
                className={classes.progress}
                />
            </span>
          </div>
          {overdue > 0 && <div style={{ marginLeft: 60, color: '#DF1D1D' }}>
            <span style={{ fontSize: 14, fontWeight: 600 }}>{overdue}</span>
            <span style={{ fontSize: 8, marginLeft: 5 }}>Task(s) crossed deadline</span>
          </div>}
        </div>
        {addTaskPermissionAccess() && renderAddTask({ milestone: milestone.key })}
      </div>
    );
  };

  const findTask = (taskId: string): any => {
    let res;
    Object.keys(tasks).filter(key => tasks[key]?.total).find((key) => {
      const task = tasks[key].tasks.find((el) => el.id === taskId);
      if (task) {
        res = task;
      };
    });
    return res;
  };

  const getMilestones = () => {
    const sortOrder: (keyof FetchShipmentTasksData)[] = [
      'DRAFT',
      'AT_ORIGIN',
      'IN_TRANSIT',
      'TRANSSHIPMENT',
      'DESTINATION',
      'COMPLETED',
      'ON_HOLD',
      'DELETED',
    ];
    return sortOrder
      .map((key) => ({
        key,
        label: MilestoneCodes[key]?.label,
        data: tasks?.[key],
      }))
      .filter((el) => el.data);
  };

  const handleCloseAddTaskDetailsModal = async (refresh: boolean) => {
    setIsTaskDetailsVisible(false);
    setState({
      isAddTaskDetailModalWrapperVisible: false,
      isAddTaskDetailModalVisible: false,
      editTaskSessionData: undefined,
    });
    if (refresh) {
      updateCardData();
      await fetchTasks(sourceObjectId);
    }
  }

  const renderEditIcon = () => {
    const isEditable = isDetailModalEditable && !onHold;
    return (
      <Icon
        type="edit"
        onClick={() => isEditable && modals.edit.show()}
        style={{
          fontSize: 12,
          color: isEditable ? '#333333' : '#D9D9D9',
          cursor: isEditable ? 'pointer' : 'auto',
        }}
      />
    );
  }

  const renderTasksList = () => {
    const columns: any = getColumns();
    return (
      getMilestones().map((milestone) => {
        const done = milestone.data?.done;
        const total = milestone.data?.total;
        const overdue = milestone.data?.overdueTaskCount;
        return (
          <Collapse
            defaultActiveKey={[currentShipmentMilestone]}
            className={classes.collapse}
            style={{
              background: total && done === total ? '#DBF3E5' : '#EDEDED',
            }}
          >
            <Collapse.Panel
              header={renderCollapseHeader({
                title: milestone.label,
                done: done,
                overdue: overdue,
                total: total,
                milestone: milestone,
              })}
              style={{
                borderRadius: '0px 4px 4px 0px',
                border: '1px solid #F7F7F7',
                backgroundColor: '#ffffff',
              }}
              key={milestone.key}
            >
              <Table
                bordered={false}
                pagination={false}
                rowKey={(record: any) => record.id}
                className={classes.table}
                columns={columns}
                size="small"
                dataSource={milestone.data?.tasks}
                rowClassName={(record: SETask) => {
                  const res = [] as string[];
                  res.push(classes.taskRow);
                  record.disabled && res.push(classes.disabledRow);
                  isDeadlinePast(record) && res.push(classes.deadlinePassedRow);
                  return res.join(' ');
                }}
              />
            </Collapse.Panel>
          </Collapse>
        );
      })
    );
  }

  const renderSpinner = () => {
    return (
      <Loader
        style={{ marginLeft: '0px', marginTop: '25px' }}
        zIndex={1}
      />
    );
  }

  const renderEditTaskModal = () => {
    return modals.edit.isVisible &&
      <SEAddTaskModal
        visible={modals.edit.isVisible}
        isEdit={true}
        handleClose={() => modals.edit.hide()}
        handleSubmit={async () => {
          updateCardData();
          modals.edit.hide((_) => modals.taskEditedProtip.show(() => { }, _));
        }}
        sourceObjectId={sourceObjectId}
        data={editTaskData}
      />;
  }

  const renderAddTaskModal = () => {
    return modals.addTask.isVisible &&
      <SEAddTaskModal
        visible={modals.addTask.isVisible}
        handleClose={() => modals.addTask.hide()}
        handleSubmit={() => {
          updateCardData();
          modals.addTask.hide((_) => modals.taskCreatedProtip.show(() => { }, _));
        }}
        sourceObjectId={sourceObjectId}
        data={editTaskData}
      />;
  }

  const renderAddTaskDetailsModal = () => {
    const isTaskApproval = editTaskData?.type?.includes('APPROVAL');
    const editable = !isTaskApproval && isDetailModalEditable;
    const showApproveActions = isTaskApproval && editTaskData?.isEditable && editTaskData?.status !== 'Done';

    return isAddTaskDetailModalVisible && (
      <SEModalWrapper
        taskData={editTaskData}
        editable={editable}
        handleCloseAddTaskDetailsModal={handleCloseAddTaskDetailsModal}
        renderEditIcon={renderEditIcon}
        renderColDeadline={renderColDeadline}
        isVisible={isAddTaskDetailModalWrapperVisible}
        showApproveActions={showApproveActions}
      >
          <SEAddTaskDetailModal
            sessionData={editTaskSessionData}
            taskData={editTaskData}
            isTaskApproval={isTaskApproval}
            editable={editable}
            taskName={editTaskData?.name}
            handleClose={handleCloseAddTaskDetailsModal}
            sourceObjectId={sourceObjectId}
            taskId={currentTaskId}
            onGotoTask={(taskId, values) => {
              setState({ editTaskSessionData: values });
              refreshAddDetailTaskModal(taskId);
            }}
            milestone={currentShipmentMilestone}
            mode={shipmentDetails?.mode || selectedShipment?.mode}
          />
        </SEModalWrapper>
      );
  }

  const renderTaskCreatedProtipModal = () => {
    return modals.taskCreatedProtip.isVisible &&
      <SEAddTaskProtip
        visible={modals.taskCreatedProtip.isVisible}
        handleClose={() => modals.taskCreatedProtip.hide()}
        handleSubmit={async () => {
          modals.taskCreatedProtip.hide();
          setState({ isAddTaskDetailModalVisible: false });
          await fetchTasks(sourceObjectId); 
        }}
      />;
  }

  const renderTaskEditedProtipModal = () => {
    return modals.taskEditedProtip.isVisible &&
      <SEEditTaskProtip
        visible={modals.taskEditedProtip.isVisible}
        handleClose={() => modals.taskEditedProtip.hide()}
        handleSubmit={async () => {
          modals.taskEditedProtip.hide();
          setState({ isAddTaskDetailModalVisible: false });
          await fetchTasks(sourceObjectId);
        }}
      />;
  }

  const renderTaskBlockerModal = () => {
    return modals.taskBlocker.isVisible &&
      <SETaskBlockerModal
        visible={modals.taskBlocker.isVisible}
        onCancel={() => modals.taskBlocker.hide()}
        data={blockingTasks}
      />;
  }

  const renderFieldMissingModal = () => {
    if (!modals.fieldMissing.isVisible) {
      return;
    }
    const ModalFooter = () => {
      return (
        <Button type="primary" onClick={handleCancel} style={{ width: 80 }}>
          Ok
        </Button>
      );
    };

    return (
      <Modal
        visible={modals.fieldMissing.isVisible}
        onCancel={handleCancel}
        title="Attention"
        footer={ModalFooter()}
      >
        <div>All mandatory fields need to be entered before task can be marked done.</div>
        <div>Please make sure you enter all the fields.</div>
      </Modal>
    );
  };

  const renderTaskRejectionModal = () => {
    return modals.taskRejection.isVisible &&
      <SETaskRejectionModal
        visible={modals.taskRejection.isVisible}
        onCancel={(_) => modals.taskRejection.hide()}
      />;
  }

  const renderUploadDocumentTaskDetails = () => {
    const isTaskApproval = editTaskData?.type?.includes('APPROVAL') && editTaskData?.status !== 'Sent For Approval';
    
    /** Cant change approvalStatus once marked approve/reject */
    const isApproveAllowed = editTaskData?.approvalStatus === ApprovalTaskStatusOptions.APPROVAL_PENDING;
    const editable = !isTaskApproval && isDetailModalEditable;

    const showApproveActions = isTaskApproval && editTaskData?.isEditable
      && editTaskData?.status !== 'Done' && (isApproveAllowed || editTaskData?.status === 'In Progress');

    return (isAddTaskDetailModalVisible && (
      <SEModalWrapper
        isShipmentOnHold={onHold}
        currentShipmentMilestone={currentShipmentMilestone}
        taskData={editTaskData}
        editable={editable}
        handleCloseAddTaskDetailsModal={handleCloseAddTaskDetailsModal}
        renderEditIcon={renderEditIcon}
        renderColDeadline={renderColDeadline}
        isVisible={isAddTaskDetailModalWrapperVisible}
        showApproveActions={showApproveActions}
        sourceObjectId={sourceObjectId}
        taskId={editTaskData?.id}
        taskFieldComponent={
          <SEAddTaskDetailModal
            sessionData={editTaskSessionData}
            taskData={editTaskData}
            isTaskApproval={isTaskApproval}
            editable={editable}
            taskName={editTaskData?.name}
            handleClose={handleCloseAddTaskDetailsModal}
            sourceObjectId={sourceObjectId}
            taskId={currentTaskId}
            gotoContainerTrackingTab={gotoContainerTrackingTab}
            onGotoTask={(taskId, values, docValues) => {
              setState({ editTaskSessionData: values , docEditTaskSessionData: docValues});
              refreshAddDetailTaskModal(taskId);
            }}
            milestone={currentShipmentMilestone}
            docEditTaskSessionData={docEditTaskSessionData}
            mode={shipmentDetails?.mode || selectedShipment?.mode}
          />
        }
      >
      </SEModalWrapper>
    ));
  }

  const renderForm13UploadModal = (): React.ReactElement => {
    return (
      <Form13UploadModal
        isVisible={isForm13UploadModalVisible}
        handleCancel={handleCloseForm13Modal}
        shipmentData={shipmentDetails}
        setDocumentTab={() => gotoDocumentRequest('form13')}
        isRetryRequest={isRetryError}
        retryRequestData={isRetryError ? retryRequestData : undefined}
        onSubmit={(success, requestBody, successResponse) => {
          if (success) {
            fetchPendingContainerCount({ shipmentId: sourceObjectId });
            setState({
              odexRequestBody: requestBody,
              odexSuccessResponse: successResponse,
              isOdexRequestSuccessModalVisible: true,
              isForm13RequestDetailsModalVisible: false,
              isRetryError: false,
              odexFormType: 'FORM13',
              isForm13UploadModalVisible: false,
            });
          } else {
            setState({
              isForm13RequestDetailsModalVisible: false,
              isForm13UploadModalVisible: false,
            });
          }
        }}
      />
    );
  };

  const handleCloseForm13Modal = () => {
    setState({
      isForm13UploadModalVisible: false,
      isForm13RequestDetailsModalVisible: false,
      isRetryError: false,
      odexRequestBody: undefined,
    });
  };

  const renderVGMSuccessModal = (): React.ReactElement => {
    const isForm13 = odexFormType === 'FORM13';

    return (
      <FileOdexSuccessModal
        shipmentId={sourceObjectId}
        isVisible={isOdexRequestSuccessModalVisible}
        openDocumentTab={() => gotoDocumentRequest('vgm')}
        openTasksTab={setTasksTab}
        handleCreateNewRequest={() =>
          setState({
            ...(isForm13 ? { isForm13UploadModalVisible: true } : { isFileVgmModalVisible: true }),
            odexRequestBody: undefined,
          })
        }
        onOkay={(isRetryError) => {
          if (isRetryError) {
            setState({
              isOdexRequestSuccessModalVisible: false,
              isRetryError: true,
              odexFormType: undefined,
              ...(isForm13
                ? { isForm13UploadModalVisible: true }
                : { isFileVgmModalVisible: true }),
            });
          } else {
            setState({
              isOdexRequestSuccessModalVisible: false,
              isRetryError: false,
              odexFormType: undefined,
            });
          }
        }}
        handleRetryRequest={(retryRequestData) => setState({ retryRequestData })}
        requestBody={odexRequestBody}
        successResponse={odexSuccessResponse}
        formType={odexFormType}
      />
    );
  };

  const renderForm13RequestDetailsModal = (): React.ReactElement => {
    return (
      <Form13RequestDetailsForm
        isVisible={isForm13RequestDetailsModalVisible}
        handleCancel={() => setState({ isForm13RequestDetailsModalVisible: false })}
        shipmentData={shipmentDetails}
        setDocumentTab={() => gotoDocumentRequest('form13')}
        openForm13Modal={() => setState({ isForm13UploadModalVisible: true })}
      />
    );
  };

  const handleRequestOdexRefNumber = async () => {
    setState({ isRequestingOdexNumber: true });
    const response = await form13RequestOdexRefNumber();
    if (response.isSuccess) {
      message.success(
        'Your request has been successfully sent. These requests are closed within 2 working days.'
      );
    } else {
      message.error(response.errorMessage);
    }
    setState({ isRequestingOdexNumber: false });
  };

  const renderUploadSIModal = (): React.ReactElement => {
    return (
      <UploadSIModal
        isVisible={isUploadSIModalVisible}
        onCancel={() => setState({ isUploadSIModalVisible: false, siTaskid: undefined })}
        shipmentData={shipmentDetails}
        taskId={siTaskid}
        setDocumentTab={() => gotoDocumentRequest('si')}
        onSubmit={(success) => {
          if (success) {
            fetchPendingContainerCount({ shipmentId: sourceObjectId });
            setState({
              isSISuccessModalVisible: true,
              isUploadSIModalVisible: false,
              siTaskid: undefined,
            });
          } else {
            setState({ isUploadSIModalVisible: false, siTaskid: undefined });
          }
        }}
      />
    );
  };

  const renderFileVGMModal = (): React.ReactElement => {
    return (
      <FileVGMModal
        isVisible={isFileVgmModalVisible}
        onCancel={() =>
          setState({
            isFileVgmModalVisible: false,
            isRetryError: false,
            odexRequestBody: undefined,
          })
        }
        shipmentData={shipmentDetails}
        isReSubmitting={isRetryError}
        setDocumentTab={() => gotoDocumentRequest('vgm')}
        retryRequestData={isRetryError ? retryRequestData : undefined}
        requestBody={odexRequestBody}
        successResponse={odexSuccessResponse}
        onSubmit={(success, odexRequestBody, odexSuccessResponse) => {
          if (success) {
            fetchPendingContainerCount({ shipmentId: sourceObjectId });
            setState({
              odexRequestBody,
              odexSuccessResponse,
              isOdexRequestSuccessModalVisible: true,
              isFileVgmModalVisible: false,
              isRetryError: false,
              odexFormType: 'VGM',
            });
          } else {
            setState({
              isFileVgmModalVisible: false,
              isRetryError: false,
              odexRequestBody: undefined,
            });
          }
        }}
        gotoDocumentRequest={() => gotoDocumentRequest('vgm')}
        isRetryRequest={!isEmpty(odexRequestBody)}
      />
    );
  };

  const renderUploadSISuccessModal = (): React.ReactElement => {
    return (
      <UploadSISuccessModal
        shipmentId={sourceObjectId}
        taskId={''}
        isVisible={isSISuccessModalVisible}
        openDocumentTab={() => gotoDocumentRequest('si')}
        handleCreateNewRequest={() => setState({ isUploadSIModalVisible: true })}
        onOkay={() => {
          setState({ isSISuccessModalVisible: false });
        }}
      />
    );
  };

  const renderSubmitOnInttraButton = (record: SETask) => {
    return (
      <Button
        className={classes.inttraButton}
        size="small"
        onClick={() => setState({ isUploadSIModalVisible: true, siTaskid: record.id })}
      >
        Submit on INTTRA
      </Button>
    );
  }

  let messageForSI;
  let messageForVGM;
  let messageForForm13;

  const getMessageForSI = (record: SETask) => {
    return (
      <span className={classes.pendingContainerCount} id="pendingCount">
        You still have {siPendingCount?.SI?.pendingContainerCount}/
        {siPendingCount?.SI?.totalContainerCount} containers pending. You can&nbsp;
        <span
          style={{
            color: '#1875F0',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
          onClick={() => setState({ isUploadSIModalVisible: true, siTaskid: record.id })}
        >
          submit a new request
          </span>
          &nbsp;else if you have the draft BL handy, you can upload and complete that task
          instead.
      </span>
    );
  }

  const isSubmitOnInttraButtonVisible = (record: SETask) => {
    return Boolean(
      showInttraShippingInstructions &&
      inttraCode &&
      record.isUploadSiTask &&
      isInttraSIAllowed &&
      siPendingCount?.SI?.pendingContainerCount &&
      siPendingCount?.SI?.totalContainerCount &&
      siPendingCount?.SI?.pendingContainerCount > 0 &&
      shipmentDetails?.mode === InquiryModes.FCL
    );
  }

  const renderSIActions = (record: SETask) => {
    if (!isSubmitOnInttraButtonVisible(record)) {
      return;
    }

    const isAnyContainerVerified = siPendingCount?.SI?.totalContainerCount !==
      siPendingCount?.SI?.pendingContainerCount;
    
    if (isAnyContainerVerified) {
      messageForSI = getMessageForSI(record);
    }

    return renderSubmitOnInttraButton(record);
  }

  const getMessageForVGM = (record: SETask) => {
    return (
      <span className={classes.pendingContainerCount}>
        You still have {siPendingCount?.VGM?.pendingContainerCount}/
        {siPendingCount?.VGM?.totalContainerCount} containers pending. You can submit a new
        request or mark the task as completed instead.
      </span>
    );
  }

  const isVGMButtonVisible = (record: SETask) => {
    const showFileVGMButton =
      odexVgmReferenceNumber &&
      siPendingCount?.VGM?.pendingContainerCount &&
      siPendingCount?.VGM?.totalContainerCount &&
      siPendingCount?.VGM?.pendingContainerCount > 0 &&
      carrierAndPortOdexCodeCheck &&
      shipmentDetails?.mode === InquiryModes.FCL;
  
    return Boolean(showFileVGMButton && record.isVgmTask);
  }

  const renderVGMActions = (record: SETask) => {

    if (!isVGMButtonVisible(record)) {
      return;
    }

    const isAnyContainerVerified =
      siPendingCount?.VGM?.totalContainerCount !==
      siPendingCount?.VGM?.pendingContainerCount;

    if (isAnyContainerVerified) {
      messageForVGM = getMessageForVGM(record);
    }

    return (
      <Button
        className={classes.inttraButton}
        size="small"
        onClick={() => setState({ isFileVgmModalVisible: true })}
      >
        Submit on ODeX
      </Button>
    );
  }

  const isForm13ButtonVisible = (record: SETask) => {
    const currentOrgId = getOrgPrettyName();

    const showRequestForm13Button =
      carrierAndPortOdexCodeCheck &&
      shipmentDetails?.mode === InquiryModes.FCL &&
      siPendingCount?.FORM13?.pendingContainerCount &&
      siPendingCount?.FORM13?.totalContainerCount &&
      siPendingCount?.FORM13?.pendingContainerCount > 0;

    return Boolean(
      showRequestForm13Button &&
      record.isForm13Task &&
      record.responsibleOrganisationId === currentOrgId
    );
  }

  const getMessageForForm13 = () => {
    const isAnyContainerVerified =
      siPendingCount?.FORM13?.totalContainerCount !==
      siPendingCount?.FORM13?.pendingContainerCount;

    if (!isValidString(odexForm13ReferenceNumber)) {
      return (
        <span className={classes.pendingContainerCount}>
          <a onClick={() => handleRequestOdexRefNumber()}>Click here</a> to submit a request
          to map ODeX reference number with Shipsy to enable this feature.
          {isRequestingOdexNumber && <Spin style={{ marginLeft: '10px' }} />}
        </span>
      );
    } else if (isAnyContainerVerified) {
      return (
        <span className={classes.pendingContainerCount}>
          You still have {siPendingCount?.FORM13?.pendingContainerCount}/
          {siPendingCount?.FORM13?.totalContainerCount} containers pending. You can submit a
            new request or mark the task as completed instead.
        </span>
      );
    }

    return;
  }

  const renderForm13Actions = (record: SETask) => {
    if (!isForm13ButtonVisible(record)) {
      return;
    }

    messageForForm13 = getMessageForForm13();

    return (
      <Button className={isValidString(odexForm13ReferenceNumber)
            ? classes.inttraButton
            : classes.requestForm13ButtonDisabled}
        size="small"
        onClick={() => {
          if (!isValidString(odexForm13ReferenceNumber)) {
            return;
          }
          setState({ isForm13RequestDetailsModalVisible: true });
        }}
      >
        Request Form 13
      </Button>
    );
  }

  const renderThirdPartyActions = (record) => {
    if (onHold) {
      return;
    }

    return (
      <>
        {renderSIActions(record)}
        {renderVGMActions(record)}
        {renderForm13Actions(record)}
      </>
    );
  };

  const renderModals = () => {
    return (
      <>
        {isUploadSIModalVisible && renderUploadSIModal()}
        {isSISuccessModalVisible && renderUploadSISuccessModal()}
        {isFileVgmModalVisible && renderFileVGMModal()}
        {isOdexRequestSuccessModalVisible && renderVGMSuccessModal()}
        {isForm13RequestDetailsModalVisible && renderForm13RequestDetailsModal()}
        {isForm13UploadModalVisible && renderForm13UploadModal()}
        {renderEditTaskModal()}
        {renderAddTaskModal()}
        
        {/* {renderAddTaskDetailsModal()} */}
        {/* {renderUploadDocumentsModal()} */}
        {renderUploadDocumentTaskDetails()}
        {renderTaskCreatedProtipModal()}
        {renderTaskEditedProtipModal()}
        {renderTaskBlockerModal()}
        {renderFieldMissingModal()}
        {renderTaskRejectionModal()}
      </>
    );
  }

  const render = () => {
    const isAnyModalVisible = isAddTaskDetailModalVisible; // TODO
    return (
      <div>
        {renderModals()}
        <div style={{ display: isAnyModalVisible ? 'none' : 'block' }} className={classes.taskListContainer}>
        {isLoading ?
          renderSpinner() :
          (isTask ?
            renderTasksList():
            renderNoTasks()
          )
        }</div>
      </div>
    );
  };

  return render();
};

export const taskTableColumnLabels = {
  sequenceNumber: 'S.N.',
  name: 'Task Name',
  status: 'Status',
  responsibleUserName: 'Assignee',
  action: '',
};

export const getTaskTableWidths = (col) => {
  switch (col) {
    case 'sequenceNumber':
      return 40;
    case 'name':
      return 280;
    case 'status':
      return 112;
    case 'responsibleUserName':
      return 156;
    default:
      return 10;
  }
};

const mapStateToProps = ({ masterData, shipmentExecutionReducer }) => ({
  permissions: masterData.permissions,
  showInttraShippingInstructions: masterData.modules.show_inttra_shipping_instructions,
  inttraCode: masterData.inttraCode,
  siPendingCount: shipmentExecutionReducer.siPendingCount,
  currentUserEmail: masterData.userData?.email,
  odexVgmReferenceNumber: masterData.odexVgmReferenceNumber,
  odexForm13ReferenceNumber: masterData.odexForm13ReferenceNumber,
  shippingLines: masterData?.globalShippingLines,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchPendingContainerCount,
}, dispatch);

const hocOptions = {
  connectRedux: {
    useRedux: true,
    mapStateToProps,
    mapDispatchToProps,
  },
  connectJss: {
    useJss: true,
    styleSheet: styles,
  },
}
export default GenericHoc(hocOptions)(SETasksList);